import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { supabase } from '../../utils/supabase';

const customStyles = {
  container: (provided) => ({
    ...provided,
    flexGrow: 1,
  }),
  control: (provided) => ({
    ...provided,
    width: '100%',
  }),
};

//useSlugAsValue allows us to vary whether we use the slug version as the value
function CollectionSelect({ onChange, value, useSlugAsValue = false }) {
  const [collections, setCollections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCollections = async () => {
      try {
        const { data } = await supabase
          .from('collections')
          .select('collection, collection_slug') // Add collection_slug
          .order('collection', { ascending: true })
          .range(0, 200); //log data to find why array is empty

        //console.log("Fetched collections:", data);

        const formattedCollections = data.map((collection) => ({
          label: collection.collection,
          value: useSlugAsValue
            ? collection.collection_slug
            : collection.collection,
        }));

        setCollections(formattedCollections);
        //console.log(formattedCounties);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching collections:', error);
      }
    };

    fetchCollections();
  }, [useSlugAsValue]);

  return (
    <>
      <Select
        options={collections}
        value={value} // This should be the value prop passed to CollectionSelect
        isLoading={isLoading}
        placeholder={value ? value.label : 'Select a collection'}
        onChange={onChange}
        styles={customStyles}
      />
    </>
  );
}

export default CollectionSelect;
